import styled from '@emotion/styled';

import { SMART_SIZE, TABLET_SIZE } from '../../styles/common';
import { BLACK, WHITE, RED } from '../../styles/color';

// メインコンテナ
export const OthersContainer = styled.div`
  margin-right: 40px;
  margin-left: 40px;

  ${SMART_SIZE} {
    margin-right: 4%;
    margin-left: 4%;
  }
`;

// タイトルエリア
export const OthersTitleArea = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 71px 0 65px 0;

  ${TABLET_SIZE} {
    padding: 36px 14px;
  }
`;

// タイトル
export const OthersTitle = styled.p`
  margin: 0;
  color: ${BLACK};
  letter-spacing: 0.05em;
  font-weight: 700;
  font-size: 30px;
  line-height: 1.5;
  text-align: center;

  ${TABLET_SIZE} {
    font-size: 24px;
  }
`;

// カテゴリーボタンエリア
export const OthersCategoryButtonSection = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;

// カテゴリーボタン
export const OthersCategoryButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 40px;
  width: 250px;
  height: 50px;
  border-radius: 25px;
  background-color: ${BLACK};
  box-shadow: 0 5px 4px 0 rgba(0, 0, 0, 0.15);
  color: ${WHITE};
  letter-spacing: 0.05em;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  cursor: pointer;
  border: none;
  user-select: none;

  &::after {
    position: absolute;
    top: 50%;
    right: 18px;
    display: block;
    width: 14px;
    height: 14px;
    background-image: url(../img/icon-arrow-down-white.svg);
    background-size: 14px 14px;
    background-repeat: no-repeat;
    content: '';
    transform: translateY(-50%);
    pointer-events: none;
  }

  &:hover {
    background-color: ${RED};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.3);
  }

  ${SMART_SIZE} {
    font-weight: 500;

    &::after {
      display: none;
    }
  }
`;
